export const clamp = (val: number, min: number, max: number) =>
  Math.min(max, Math.max(min, val));

// Mobile zoom utility functions
export const getDistance = (
  touch1: { x: number; y: number },
  touch2: { x: number; y: number }
) => {
  const dx = touch2.x - touch1.x;
  const dy = touch2.y - touch1.y;
  return Math.sqrt(dx * dx + dy * dy);
};

export const getMidpoint = (
  touch1: { x: number; y: number },
  touch2: { x: number; y: number }
) => {
  return {
    x: (touch1.x + touch2.x) / 2,
    y: (touch1.y + touch2.y) / 2,
  };
};

/**
 * Swallow the compatibility `click` a browser synthesises after a touch tap.
 *
 * The map acts on `pointerup`, so whatever a building tap opens — the arena
 * dialog, a build/collect confirm, or a whole new route — is already mounted by
 * the time that click is dispatched. The click is hit-tested against the DOM as
 * it stands at dispatch time, not against the canvas that was actually tapped,
 * so it lands a second, unasked-for activation on whatever now sits under the
 * finger. Tapping Arena opened the dialog and the follow-up click hit its Shop
 * tile, dumping the player on /marketplace; the same click could just as easily
 * hit "Yes" on a build confirm and spend resources.
 *
 * Mouse input is unaffected (a real click targets the common ancestor of
 * mousedown/mouseup — the canvas), so callers should only arm this for touch.
 */
export const swallowGhostClick = (): void => {
  if (typeof window === "undefined") return;

  const cleanup = () => {
    window.removeEventListener("click", swallow, true);
    window.clearTimeout(timer);
  };

  function swallow(event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
    cleanup();
  }

  // Capture phase, so it runs before the click reaches whatever just mounted.
  window.addEventListener("click", swallow, true);
  // If no ghost click arrives, disarm — never leave it primed to eat a real one.
  const timer = window.setTimeout(cleanup, 400);
};
